import { useVezgoIntegrate } from 'api'
import { useHideModal } from 'components/Modals'
import { useLocalization } from 'localization'
import { useShowModal } from 'modules/common/GlobalModals'
import { useEffect, useState } from 'react'
import VezgoService from 'utils/vezgo'

export const useIntegrationsTab = () => {
	const { t } = useLocalization()
	const [widgetLoaded, setWidgetLoaded] = useState(false)
	const { mutateAsync: integrate } = useVezgoIntegrate()
	const showModal = useShowModal()
	const hideModal = useHideModal()
	const [error, setError] = useState<Record<string, unknown> | null>()

	useEffect(() => {
		if (error?.message === 'Connection refused') {
			hideModal()
			setTimeout(() => {
				showModal('integrations.add')
			}, 1)
			return
		}
		if (error) {
			setWidgetLoaded(false)
		}
	}, [error])

	useEffect(() => {
		if (!error) {
			VezgoService.init().then(() => {
				VezgoService.startWidget(async accountId => {
					const accountInfo = await VezgoService.getAccountInfo(accountId)

					if (accountInfo) {
						await integrate({
							accountId,
							source: accountInfo.provider.display_name.toUpperCase(),
						})
					}
					hideModal()
				}, setError)
				// simulate loading and give a space for iframe to initialize
				setTimeout(() => {
					setWidgetLoaded(true)
				}, 3000)
			})
		}
	}, [error])

	return { widgetLoaded, error, setError, t }
}
